import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './EvBookingEditor.html?raw';
import topic from 'dojo/topic';
import "./EvBookingEditorTypes";

import EvBookingEditorForm from './EvBookingEditorForm/EvBookingEditorForm';
import './EvBookingEditorForm/EvBookingEditorForm';
import GenericDialog from '../../moreCore/UI/GenericDialog/GenericDialog';
import '../../moreCore/UI/GenericDialog/GenericDialog';
import { EvBookingCopyForm, VAMtypes } from "../_loadingHelpers/VAM";
import "../../moreCore/UI/Floating/Menu";
class EvBookingEditor extends compose(_WidgetBaseSP) {
	templateString: any = template;

    formContainer: HTMLElement;

    editorForm: MdsLax<InstanceType<typeof EvBookingEditorForm>> = null;
    evBookingEditorSectionsConfig: EvBookingEditor_SectionsConfig = null;

    dlg: MdsLax<InstanceType<typeof GenericDialog>> = null;

    is_validation_enabled = true;

    isDialog: boolean = true; // ob die Form in einem Dialog aufgehen soll oder im formContainer 
    isNewStatus: boolean = false;

    isValidationEnabled: boolean = true;
    existingEntity: VAMtypes.EvBookingEditorEntity = null;

    loadConfigFromBackend = false;

    _request: any = null;

    // wenn eine Entity schon da ist
    setEditorEntity(entity: VAMtypes.EvBookingEditorEntity): void {

        if (entity) {
            if (/*this.dlg && */this.hasUserRole("EvBooking_Edit") ) {

                this.existingEntity = entity as VAMtypes.EvBookingEditorEntity;

                if (this.editorForm != null) {
                    this.editorForm.setExistingEntity(this.existingEntity);
                }
            }
        }
    }

    loadEntityById(entityId: string): void {

        if (!this.editorForm) {
            this.StandbyStart();
        } else {

            this.StandbyStart(this.editorForm.domNode);
        }

        if (entityId && typeof entityId == "string") {
            if (this._request != null) {
                this._request.cancel();
            }

            let data = { ID: entityId };

            this._request = this.RequestManager.post(
                window.appRoot + "EvBookingEditor/GetEntityById",
                {
                    jsonData: JSON.stringify(data)
                },

                lang.hitch(this, this._onLoadEntityByIdResult),

                lang.hitch(this, function (err: { Message: string }) {
                    this.StandbyStop();
                    if (err && err.Message) {
                        alert(err.Message);
                    } else {
                        console.log(err);
                    }
                }),
                false // sync
            );

        } else if (typeof entityId != "string") {
            console.error("Type of entityId should be string", entityId);
            this.isNewStatus = true;
        } else {
            throw "No Entity Id provided";
        }
    }

    _onLoadEntityByIdResult(response: VAMtypes.EvBookingEditorEntity): void {
        this.StandbyStop();

        if (response && response["ID"]) {
            this.setEditorEntity(response);
            if (!this.editorForm) {
                this.showBookingEditorForm();

            }

            this.emit("loaded", response);
            this.editorForm.resetFileUploadInput(); // Nach dem Speichern wird es nicht neu geladen und alte Dateien-Rows bleiben
        } else {
            console.error(response);
        }
    }

    _onclickEditorFormLink(evt: Event): void {
        this.showBookingEditorForm();
    }

    _onclickEditorFormButton(evt: Event): void {
        this.showBookingEditorForm();
    }

    setEvBookingEditorConfig(config: EvBookingEditor_SectionsConfig): void {

        this.evBookingEditorSectionsConfig = config;
    }

    private _handleSectionVisibilities(form: MdsLax<InstanceType<typeof EvBookingEditorForm>>): void {

        if (this.evBookingEditorSectionsConfig !== null) {
            form.evBookingEditorSectionsConfig = this.evBookingEditorSectionsConfig;

            if (!this.evBookingEditorSectionsConfig.isBookerSectionVisible) this.hideNode(form.bookerInputSection_container);
            if (!this.evBookingEditorSectionsConfig.isTicketSectionVisible) this.hideNode(form.ticketsSection_container);

            if (!this.evBookingEditorSectionsConfig.isCastListVisible) form.bookingListTablesConfig[EvBookingEditor_ListNames.EvCast].isVisible = false;
            if (!this.evBookingEditorSectionsConfig.isProgramListVisible) form.bookingListTablesConfig[EvBookingEditor_ListNames.EvProgram].isVisible = false;            
            if (!this.evBookingEditorSectionsConfig.isEvCategoriesListVisible) form.bookingListTablesConfig[EvBookingEditor_ListNames.evCategories].isVisible = false;
            if (!this.evBookingEditorSectionsConfig.isOrchesterEmployementsListVisible) form.bookingListTablesConfig[EvBookingEditor_ListNames.orchesterEmployements].isVisible = false;
            if (!this.evBookingEditorSectionsConfig.isServiceListVisible) form.bookingListTablesConfig[EvBookingEditor_ListNames.EvService].isVisible = false;            
            if (!this.evBookingEditorSectionsConfig.isEvTasksListVisible) form.bookingListTablesConfig[EvBookingEditor_ListNames.evTasks].isVisible = false;            
            if (!this.evBookingEditorSectionsConfig.isFilesSectionVisible) form.bookingListTablesConfig[EvBookingEditor_ListNames.existingFiles].isVisible = false;
        }

        form.adjustSectionsVisibility();
    }

    private createEditorForm(): void {
        if (this.editorForm != null) {
            this.editorForm = null;
        }

        this.editorForm = new EvBookingEditorForm();
        this._handleSectionVisibilities(this.editorForm);

        if (this.existingEntity) {
            this.editorForm.setExistingEntity(this.existingEntity as VAMtypes.EvBookingEditorEntity);
        }
        
        if (this.isNewStatus) {
            if (this.evBookingEditorSectionsConfig?.isBookerSectionVisible) {

                this.editorForm.setBookerInputPresetValue(window.sessionInfo.sessionData.CurrentEmployeeId);
                this.editorForm.bookerInput.setReadonly(false);
            }
            if (this.hasFeature("EvBooking/DefaultProject")) this.editorForm.setEmptyProjectValue();
        }

        this.editorForm.setIValidationEnabled(this.isValidationEnabled);
        //this.editorForm.setIsFormInDialog(this.isDialog);

        this.editorForm.on("bookingEditorFormResponse", lang.hitch(this, this._onEditorFormResponse));
        this.editorForm.on("saveButtonClick_noChanges", lang.hitch(this, this._onEditorFormSaveClickNotDirty));
        this.editorForm.on("bookingEditorPricelistCalculationResponse", lang.hitch(this, this._reloadCurrentEntityInEditor));
        this.editorForm.on("bookingEditorAssignAssociateResponse", lang.hitch(this, this._reloadCurrentEntityInEditor));
    }

    showBookingEditorForm(showInStandaloneDlg: boolean = true, entity?: any): void {

        this.formContainer.innerHTML = null;

        if (showInStandaloneDlg === true || showInStandaloneDlg === false) this.isDialog = showInStandaloneDlg;

        if (this.isDialog == false) {

            if (entity) {
                this.existingEntity = entity;
            }

            this.createEditorForm();

            this.editorForm.placeAt(this.formContainer);

        } else {

            if (this.dlg != null) {
                this.dlg.destroy();
                this.dlg = null;
            }

            this.dlg = new GenericDialog();
            this.dlg.closeOnEnter = false;
            this.UiModder.domStyle.set(this.dlg.modalDlgContentNode, "max-width", "800px");
            this.UiModder.domStyle.set(this.dlg.modalDlgContentNode, "margin", "auto");
            this.dlg.set("header", this.existingEntity ? this.translations["EvBookingditor_dialogHeader"] : this.translations["BookingEditor__CreateNewBooking"]);
            //this.dlg.set("CancelBtn", true);
            this.dlg.set("CloseBtn", true);
            this.dlg.addButton("save", this.translations["EvBookingditor_saveDataButton_label"], lang.hitch(this, this.saveFormData), null, "accentBG", "fas fa-save", false)
            //this.dlg.setUserdefinedButton(this.translations["EvBookingditor_saveDataButton_label"], "fa fa-check", lang.hitch(this, "_onclickDialogButtonSendData"), false);
            this.dlg.on("closed", lang.hitch(this, this._onClosedDialog))
            //this.dlg.on("click", function (evt) { evt.stopPropagation();})
            //this.dlg.propagateClick = false;

            //this.dlg.addButton("menu", "", lang.hitch(this, this._showActionsMenu), null, null, "fas fa-ellipsis-h", false, "last");

            this.createEditorForm();

            this.dlg.addWidgetToContent(this.editorForm);
            this.dlg.show();

            //this.editorForm.startup(); // wenn aktiv wird der bookerINput geladen und spinnnt????!?!?!?!
        }

        this.editorForm.on("entityDeleted", lang.hitch(this, this._onEntityDeleted));
    }

    _onEntityDeleted(): void {
        if (this.dlg) {
            this.dlg.close(-2);
        }
        this.emit("entityDeleted");
    }

    _onclickDialogButtonSendData(evt: MouseEvent) {
        this.saveFormData();
    }
    saveFormData(): void {
        this.editorForm.saveFormData();
    }

    deleteEvBooking(): void {
        this.editorForm.deleteEvBooking();
    }

    _onClosedDialog(): void {
        
    }

    _onEditorFormResponse(message): void {

        if (message == "success") {
            if (this.dlg) {
                this.dlg.close();
            }
            //alert(this.translations["EvBookingditor_saveData_success"]);
            topic.publish("EvBookingEditor/_onEditorFormResponse", message)
            this.emit("saveDataResponse", message);


            // aktualisierte Daten abfragen und Fenster neu öffnen
            //

            this._reloadCurrentEntityInEditor();
        }
    }

    _reloadCurrentEntityInEditor(): void {
        this.loadEntityById(this.existingEntity.ID);
    }

    _onEditorFormSaveClickNotDirty(): void {
        topic.publish("EvBookingEditor/_onEditorFormSaveClickNotDirty");
       // alert(this.translations["EvBookingditor_saveClick_notDirty"]);
    }

    // GEtters && Setters ---------------------------------------START
    _getIsValidationEnabledAttr(): boolean {
        return this.getIsValidationEnabled();
    }
    _setIs_validation_enabledAttr(bool: boolean): void {
        this.setIsValidationEnabled(bool);
    }
    getIsValidationEnabled(): boolean {
        return this.is_validation_enabled;
    }
    setIsValidationEnabled(bool: boolean): void {
        this.isValidationEnabled = bool;
        if (this.editorForm != null) {
            this.editorForm.setIValidationEnabled(this.isValidationEnabled)
        }
    }

    
    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);        
    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(EvBookingEditor);